import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { ENV } from '@constants/env';
import constants from '@constants/constants.json';

export const initDatadog = (): void => {
  // Datadog must never run locally.
  if (ENV === 'local') {
    return;
  }

  datadogRum.init({
    applicationId: 'bfc0a78d-c85b-4d5f-ac9f-6b8b714fd8ff',
    clientToken: 'pub23c1dfa91ccc5f652b1c031ed1239233',
    site: 'us3.datadoghq.com',
    service: 'tendril-v3',
    env: ENV,
    version: constants.buildVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    plugins: [reactPlugin({ router: false })],
  });
};
